import { render, staticRenderFns } from "./BranchDcCodePrefixTab.vue?vue&type=template&id=f43b42d4&scoped=true"
import script from "./BranchDcCodePrefixTab.vue?vue&type=script&lang=js"
export * from "./BranchDcCodePrefixTab.vue?vue&type=script&lang=js"
import style0 from "./BranchDcCodePrefixTab.vue?vue&type=style&index=0&id=f43b42d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43b42d4",
  null
  
)

export default component.exports